import { render, staticRenderFns } from "./ProfilePlayersSingle.vue?vue&type=template&id=9208a35e&scoped=true"
import script from "./ProfilePlayersSingle.vue?vue&type=script&lang=js"
export * from "./ProfilePlayersSingle.vue?vue&type=script&lang=js"
import style0 from "./ProfilePlayersSingle.vue?vue&type=style&index=0&id=9208a35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9208a35e",
  null
  
)

export default component.exports